var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPAddressWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.668 4.99935H13.3346V3.33268C13.3346 2.40768 12.593 1.66602 11.668 1.66602H8.33464C7.40964 1.66602 6.66797 2.40768 6.66797 3.33268V4.99935H3.33464C2.40964 4.99935 1.6763 5.74102 1.6763 6.66602L1.66797 15.8327C1.66797 16.7577 2.40964 17.4993 3.33464 17.4993H16.668C17.593 17.4993 18.3346 16.7577 18.3346 15.8327V6.66602C18.3346 5.74102 17.593 4.99935 16.668 4.99935ZM11.668 4.99935H8.33464V3.33268H11.668V4.99935Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPAddressWork);
export default __webpack_public_path__ + "static/media/p_address_work.144e054ca8571a171882bffbb0f838ff.svg";
export { ForwardRef as ReactComponent };